<template>
  <div class="loading-container" v-show="isshow">
    <div class="loading">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
export default {
  setup(props) {
    let state = reactive({
      text: props.text || '',
      isshow: false
    })
    function show() {
      state.isshow = true
    }
    function hide() {
      state.isshow = false
    }
    return {
      ...toRefs(state),
      show,
      hide
    }
  }
}
</script>
<style scoped lang="less"></style>
